import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { AvailabilityService } from '../../services/jrni/availability.service';
import { BasketService } from '../../services/jrni/basket.service';
import { DepartmentService } from '../../services/jrni/department.service';
import { ServicesService } from '../../services/jrni/services.service';
import { AlertService } from '../../_alert';
import { DatastoreService } from '../../services/datastore.service';
import { MemberService } from '../../services/jrni/member.service';
import { ApiService } from '../../services/jrni/api.service';

@Component({
  selector: 'app-calendar',
  templateUrl: './calendar.component.html',
  styleUrls: ['./calendar.component.scss'],
})
export class CalendarComponent implements OnInit {
  selectedDepartment;
  pageTitle;
  calendarPageText;
  minDate;
  maxDate;
  selectedDate: Date;
  currentDate: Date;
  selectedService;
  selectedLocation;
  slots: [];
  selectedSlot: any = undefined;
  availableDays: any;
  component: string;
  bookingsLimit: string;
  slotSelectionError = false;
  noMoreDates = false;
  agentMode: any;

  constructor(
    private router: Router,
    private departmentService: DepartmentService,
    private servicesService: ServicesService,
    private availabilityService: AvailabilityService,
    private alertService: AlertService,
    private basketService: BasketService,
    private translateService: TranslateService,
    private spinner: NgxSpinnerService,
    public datastoreService: DatastoreService,
    private memberService: MemberService,
    private apiService: ApiService
  ) {
  }
  breadcrumbItems = [
    { text: 'Home', href: '/start' },
		{ text: 'Ceremony Selection', href: '/services' },
    { text: 'Date & Time', href: '/calendar' },
  ];

  routerGoBack() {
    this.router.navigate(['/services']);
  }

  restartJourney() {
    this.router.navigate(['']);
  }

  slotSelected(slot: unknown) {
    console.log('slot selected', slot);
    this.selectedSlot = slot;
  }

  ngOnInit() {
    this.scrollToTop();
    this.component = 'calendar';
    this.spinner.show();

    this.agentMode = localStorage.getItem('agent');
    // Use this.departmentService.getLocation() if the services are set on the children departments
    // Use this.departmentService.get() if the services are set on the parent department
    this.departmentService.get().then(
      (selectedDepartment) => {
        if (selectedDepartment === undefined) {
          this.restartJourney();
        } else {
          this.selectedDepartment = selectedDepartment;

          this.departmentService.getLocation().then((selectedLocation) => {
            this.selectedLocation = selectedLocation;
            console.log('selected location: ', this.selectedLocation);
          });

          // this.selectedLocation = this.departmentService.getLocation();

          // Set the current date to today for the calendar to default to today
          this.currentDate = new Date();
          this.selectedDate = this.currentDate;

          console.log('selected department');
          console.log(this.selectedDepartment);
          if (this.selectedDepartment.hasOwnProperty('extra')) {
            console.log('setting calendar page text');
            // Set the title on the login page to the title from the business question
            this.pageTitle = this.selectedDepartment.extra.hasOwnProperty(
              'calendar_page_title'
            )
              ? this.selectedDepartment.extra.calendar_page_title
              : this.translateService.instant('CALENDAR.CALENDAR_TITLE');
          }

          // Retrieve the selected service
          this.servicesService.get().then(async (service) => {
            console.log('selected service: ', service);
            this.selectedService = service;

            // Clear the basket
            if (this.datastoreService.adminJourney) {
              console.log('Admin journey. Use v1');
              this.basketService.deleteAllBaskets(this.selectedDepartment).then(async (data) => {
                this.basketService.currentBasket = await this.basketService.createBasket(this.selectedDepartment);
                console.log('Basket created', this.basketService.currentBasket);
              })
                .catch((err) => {
                  this.alertService.error(this.translateService.instant('COMMON.GENERAL_ERR'));
                });
            }
            else {
              const basket = this.apiService.createBasket(this.selectedLocation).subscribe((response) => {
                if (response.headers.has('auth-token')) {
                  const authToken = response.headers.get('auth-token');
                  localStorage.setItem('auth_token', authToken);
                  console.log(`Set auth token from basket: ${authToken}`);
                }
                this.basketService.currentBasket = response.body;
                console.log(this.basketService.currentBasket);
                this.spinner.hide();
              });
            }

            // Clear the basket
            this.basketService
              .deleteAllBaskets(this.selectedDepartment)
              .catch((err) => {
                this.alertService.error(
                  this.translateService.instant('COMMON.GENERAL_ERR')
                );
              });

            this.spinner.hide();
          });
        }
      },
      (err) => {
        this.alertService.error(
          this.translateService.instant('COMMON.GENERAL_ERR')
        );
        this.spinner.hide();
      }
    );
  }

  continue() {
    console.log('cal continue clicked');
    this.alertService.clear();
    this.availabilityService.getSelectedSlot().then(async (slot) => {
      if (slot) {
        // now we add the item
        let resource;
        try {
          // Pass the resource id, not the whole resource object. The basket calls coerce
          // whatever they are given, but an object previously reached JRNI as
          // resource_id: null, and JRNI then silently assigns whatever resource is free at
          // that slot — booking the customer into the wrong room.
          resource = await this.availabilityService.getSelectedResource();
        }
        catch (err) {
          console.error(err);
          this.alertService.error(this.translateService.instant('COMMON.GENERAL_ERR'))
          this.spinner.hide();
        }
        try {
          this.spinner.show();
          console.log('adding item to basket', this.datastoreService.adminJourney);
          if (this.datastoreService.adminJourney) {
            console.log('Admin journey. Use v1');
            const res: any = await this.basketService.addItemV1(
              this.selectedLocation,
              this.selectedService.id,
              this.selectedService.calculated_duration,
              slot.start,
              [],
              false,
              resource
            );
            console.log(`Item added to basket 1`, res);
            this.basketService.currentBasket = res;
            this.basketService.currentServiceItem = res._embedded.items[0];
          }
          else {
            console.log('Not admin journey. Use public api');
            console.log('selected sugegstion', this.datastoreService.selectedSuggestion);
            const serviceItem = await this.apiService.addServiceItem(
              this.selectedLocation,
              this.basketService.currentBasket,
              slot.start,
              this.selectedService,
              [],
              this.selectedService.calculated_duration,
              resource
            );
            console.log(`Item added to basket 2`, serviceItem);
            this.basketService.currentServiceItem = serviceItem;
          }
          this.router.navigate(['/booking-details']);
        }
        catch (err) {
          console.error(err);
          this.alertService.error(this.translateService.instant('COMMON.GENERAL_ERR'))
          this.spinner.hide();
        }
      } else {
        this.alertService.warn(this.translateService.instant('CALENDAR.SLOT_WARNING'));
        this.slotSelectionError = true;
        this.scrollToTop();
      }
    });
  }

  onNoMoreDatesError(event) {
    this.noMoreDates = event;
  }

  // scroll to the top of the page
  scrollToTop() {
    const scrollToOptions = { top: 0, left: 0, behavior: 'instant' };
    window.scrollTo(scrollToOptions as unknown as ScrollToOptions);
  }
}
